import * as React from 'react';
import { Field, reduxForm, InjectedFormProps } from 'redux-form';
import { connect } from 'react-redux';
import { RenderField, Validators } from '../../Layout/Form/Fields/_Fields';
import { withTranslation  } from 'react-i18next';
import * as UserModule from 'Modules/UserModule';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import {compose} from 'redux';

type ConnectedProps = {
    userStore: UserModule.Types.UserStore;
    viewManagementStore: ViewManagementModule.Types.ViewManagementStore;
    t: Function;
};
type Props = {
    toggleFormsVisibility: Function;
};
const ActivateUserCompleteForm = (props: InjectedFormProps & ConnectedProps & Props) => {
    const { handleSubmit, pristine, submitting, t, userStore, toggleFormsVisibility } = props;
    return (
        <form className="form" onSubmit={handleSubmit}>
            <h2>{t('activateAccountComplete')}</h2>
            {userStore.error.activateUserErr && <p className="form_field--error form_field--error_msg">{t(`errors:activateUserComplete.${userStore.error.activateUserErr.errorSubcode}`)}</p>}
            {userStore.success.activateUserSuccess && <p className="form_field--success form_field--success_msg">{t('activateUserSuccess')}</p>}
            {userStore.error.activateUserErr && userStore.error.activateUserErr.errorSubcode === 'VALID_TOKEN_NOT_FOUND' && (
                <p>
                    <button className="btn btn--clean" onClick={() => toggleFormsVisibility()}>
                        {t('generateTokenAgain')}
                    </button>
                </p>
            )}
            <Field name="password" component={RenderField} type="password" placeholder={t('password')} label={t('password')} validate={[Validators.required, Validators.password]} />
            <button disabled={submitting || pristine} className="btn btn--blue" type="submit">
                {t('send')}
            </button>
        </form>
    );
};

function mapStateToProps(state: any) {
    return {
        viewManagementStore: state.viewManagementStore,
        userStore: state.userStore
    };
}


export default compose(
    connect(mapStateToProps),
    withTranslation (['forms', 'errors']),
    reduxForm({
        form: 'activateUserComplete'
    })
)(ActivateUserCompleteForm) as React.ComponentClass<any>



// WEBPACK FOOTER //
// ./src/components/UserSigning/Forms/_ActivateUserCompleteForm.tsx